// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-locked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.499 17.5H21.499V22H14.499V17.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4V22H10.5M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.75 17.5V15.75C15.75 14.5074 16.7574 13.5 18 13.5C19.2426 13.5 20.25 14.5074 20.25 15.75V17.5M14.499 17.5H21.499V22H14.499V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileLockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-locked',
    ref,
    icon: element,
  },
));

FileLockedIcon.displayName = 'FileLockedIcon';

export default FileLockedIcon;
